import { createContext } from 'react';

interface IThemeContext {
  themeName: string;
}

const initialState: IThemeContext = {
  themeName: 'default',
};

export default createContext<IThemeContext>(initialState);
